import React, { memo, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { mutateProcedure } from "../../../../../store/patients/mutateProcedure";
import { DOC_DEDUP_TYPE } from "../../../../../store/patients/mutateProcedure/config";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { useQuestionnaireOptions } from "../../shared/Documents/hooks/useQuestionnaireOptions";
import {
  dedupSelectedDocumentOptions,
  pickSelectedOptions,
} from "../../shared/Documents/Documents.utils";
import { dispatch } from "../../../../../store/store";
import { InputLabel } from "../../../../../shared/InputLabel/InputLabel";
import { Select } from "../../../../../shared/Select/Select";
import styles from "./styles.module.scss";

const { selectors, actions } = mutateProcedure;

const mapStateToProps = (state) => ({
  isDeduping: selectors.selectIsDocsDeduping(
    DOC_DEDUP_TYPE.providerQuestionnaire,
  )(state),
});

export const ProviderQuestionnaires = memo(
  connect(mapStateToProps)(
    ({ appointmentId, procedureId, serviceId, ids, isLoading, isDeduping }) => {
      const { tCommon: t } = useAppTranslation.Common();

      const options = useQuestionnaireOptions({
        appointmentId,
        procedureId,
        serviceId,
        select: ids.appendAsNonDeletable,
        providerQuestionnairesOnly: true,
      });

      const selectedOptions = useMemo(
        () => pickSelectedOptions(ids.value, options.data),
        [options.data, ids.value],
      );

      useEffect(() => {
        if (isDeduping && procedureId) {
          const nextIds = dedupSelectedDocumentOptions(
            ids.value,
            options.patientDocuments,
          );

          dispatch(
            actions.finishDocumentsDedup(DOC_DEDUP_TYPE.providerQuestionnaire),
          );
          ids.replaceRawIds(nextIds);
        }
      }, [ids.value, options.patientDocuments, isDeduping, procedureId]);

      return (
        <div className={styles.root}>
          <InputLabel>{t("label.selectProviderQuestionnaires")}</InputLabel>
          <Select
            isMulti
            isSearchable
            options={options.data}
            value={selectedOptions}
            onChange={ids.onChange}
            isLoading={isLoading || options.isLoading}
            isOptionClearable={(option) => ids.isDeletable(option.value)}
          />
        </div>
      );
    },
  ),
);
